<template>
  <div>
    <div class="flex items-center justify-center flex-wrap">
      <div
        v-for="emoji in (1, 6)"
        :key="emoji"
        class="flex items-center justify-center h-32 w-32 m-2"
        :class="{ 'rounded-full border': value && value === emoji }"
      >
        <img
          class="cursor-pointer h-16"
          :src="`/images/avatars/${emoji}.png`"
          @click="$emit('input', emoji)"
        >
      </div>
    </div>
    <p v-if="message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    }
  },
  props: ['name', 'value', 'message'],
}
</script>
